/**
 * Static how-to guide for the on-site network scan (IBM-1039): the "OTTO
 * Network Scan Kit" page under `public/help/network-scan-kit/` — what to
 * order, where and how to test, how to read the LEDs, what to do without a
 * connection. It is a plain HTML file outside the React bundle with its own
 * EN/DE/FR/KO/ZH texts, so the user's language and brand accent travel in the query
 * string (see the comment at the top of that file).
 */
export type NetworkScanGuideBrand = 'busch' | 'argos';

export interface NetworkScanGuideUrlOptions {
    /** i18n language (also regional variants like `de-DE`); languages the page has no texts for fall back to English. */
    lng?: string | null;
    /** Accent colour of the page; defaults to the Busch / OTTO accent. */
    brand?: NetworkScanGuideBrand | null;
    /** Shown inside the app's guide modal: the page hides its own top bar (language / print). */
    embed?: boolean;
}

/** Languages the guide page has texts for (dictionaries in its index.html). */
const GUIDE_LANGUAGES = ['en', 'de', 'fr', 'ko', 'zh'];

export const NETWORK_SCAN_GUIDE_PATH = '/help/network-scan-kit/index.html';

export const buildNetworkScanGuideUrl = ({ lng, brand, embed }: NetworkScanGuideUrlOptions = {}): string => {
    const base = (lng ?? '').toLowerCase().split('-')[0];
    const language = GUIDE_LANGUAGES.includes(base) ? base : 'en';
    const accent: NetworkScanGuideBrand = brand === 'argos' ? 'argos' : 'busch';
    const query = `lng=${language}&brand=${accent}${embed ? '&embed=1' : ''}`;
    return `${process.env.PUBLIC_URL || ''}${NETWORK_SCAN_GUIDE_PATH}?${query}`;
};
